/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payors/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ArrowLeft from './ArrowLeft/index'
import ArrowRight from './ArrowRight/index'
import Payor from './Payor/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payors({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors",
  scrollContainerRef
  
}) {
let payorsValueData = fromData.useDataValue({ viewPath,
context: 'payors',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Payors.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ArrowLeft
  viewPath={`${viewPath}/ArrowLeft`}
 scrollContainerRef={scrollContainerRef}
/>
<div
  data-testid="Payors.Vertical:1"
  data-view-path={viewPath}
 scrollbarWidth="none"
 msOverflowStyle="none"
 ref={scrollContainerRef}
 className={`views-block hide-scrollbar ${styles.Vertical1}`}
>
<div
  data-testid="Payors.List"
  data-view-path={viewPath}
 style={{'--g-1-Z2g2GCs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(payorsValueData) && payorsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="payor"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Payor(${item?.id ?? item?._id ?? index})`}
      >
<Payor
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Payor(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 scrollContainerRef={scrollContainerRef}
/>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }